import { memo } from 'react'
import './styles.css'

const Tag = memo(function Tag({ children, variant = 'default', className = '', ...props }) {
  return (
    <span className={`tag tag--${variant} ${className}`} {...props}>
      {children}
    </span>
  )
})

export default Tag
